// "Doe mee": the one way into someone's shared tasting from a row, a sheet or the Samen list. It is
// only rendered when the edge said the viewer may join, so there is nothing to explain when absent.
import { useState } from "react";
import { useT } from "../lib/i18n";
import { joinTasting } from "../lib/social/joinTasting";
import type { PresenceView } from "../lib/social/lastActive";
import { Button, Icon } from "../ui";

export function JoinTastingButton({
  join,
}: {
  join: NonNullable<PresenceView["join"]>;
}): React.JSX.Element {
  const { t } = useT();
  const [busy, setBusy] = useState(false);
  return (
    <Button
      tone="primary"
      disabled={busy}
      icon={<Icon name="glass" size={16} />}
      aria-label={t("social.presence.joinLabel", { name: join.name })}
      data-testid={`join-tasting-${join.sessionId}`}
      onPress={() => {
        setBusy(true);
        joinTasting(join.sessionId, join.right)
          .catch(() => undefined)
          .finally(() => {
            setBusy(false);
          });
      }}
    >
      {t("social.presence.join")}
    </Button>
  );
}
